import { AfterViewInit, Component, ElementRef, EventEmitter, Injector, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { T2CardComponent } from '../../../../../trip2-theme/components/t2-card/t2-card.component';
import { ParentModule } from '../../../ParentClass/parent-module';
import { ManifestService } from '../../manifest.service';
import { GridOptions } from 'ag-grid';
import { T2LoadingService } from '../../../../../trip2-theme/components/t2-loading/t2-loading.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { IDataManifestCreate, IMatchInfoTrip } from '../../../../../core/interfaces/manifest.interface';
import { ProvidersBillingService } from 'app/pages/providers-billing/providers-billing-service.service';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { MatchPropConst } from 'app/core/enums/match-prop';
import 'rxjs/add/operator/finally';

declare const pdfjsLib: any;
declare const jsPDF: any;
declare const Cropper: any;

@Component({
  selector: 'app-manifest',
  templateUrl: './manifest.component.html',
  styleUrls: ['./manifest.component.scss']
})
export class ManifestComponent extends ParentModule implements OnInit, AfterViewInit, OnDestroy {
  public form: FormGroup;
  protected b64File: string;
  protected strSubstr: string;
  protected str: string;
  gridTrips: GridOptions;
  reviewedName = null;
  reviewedByOn = null;
  public isUnableToSign = '';
  protected uploadManifest = false;
  protected approveDenyClaim = false;

  @Input() tripIdInput?: any;
  @Input() isStandingOrder? = false;
  @Input() autoOpen = true;
  @Input() tripids?: any[];
  protected base64File: string;
  @ViewChild('iframeManifest') private iframeManifest: ElementRef;
  @ViewChild('file') private file: ElementRef;
  @ViewChild('popManifest') popManifest: T2CardComponent;
  @ViewChild('myCanvas') __CANVAS: ElementRef;
  @ViewChild('image') public image: ElementRef;
  @ViewChild('fs') fs: ElementRef;
  public fileLink: string;
  public _cropperImg: any;
  swicth = true;
  protected configImg = {
    aspectRatio: 16 / 9,
    checkCrossOrigin: false,
    background: false,
    checkOrientation: true,
    scalable: true,
    rotatable: true,
    viewMode: 2,
  };

  public __CANVAS_CTX: CanvasRenderingContext2D ;

  public __PDF_DOC;
  public __CURRENT_PAGE;

  public __TOTAL_PAGES;

  public __PAGE_RENDERING_IN_PROGRESS = 0;
  public img = new Image;
  public buff = [];
  public storedRects = []; // so far we only deal with single page editor, if multipaged. we will need to update
  // to update the redo and undo structure, with multi buffs, or we just commit the change, and forget about re-editing
  public allPages = [];
  public show = false;
  public refresh = true;
  protected infTrip: any; // Trip Information
  @Output() eventManifest: EventEmitter <any> = new EventEmitter <any>();
  @Output() onClose?: EventEmitter <any> = new EventEmitter <any>();
  @Output() onRealoadCheck?: EventEmitter <any> = new EventEmitter <any>();
  public matchInfoTrip: IMatchInfoTrip[] = [];
  public scoreValue: number;
  public matchProp = {
    dos: MatchPropConst.dos,
    memberName: MatchPropConst.memberName,
    trip: MatchPropConst.trip,
    los: MatchPropConst.los,
    signature: MatchPropConst.signature,
    miles: MatchPropConst.miles,
    vin: MatchPropConst.vin,
    vehicleCode: MatchPropConst.vehicleCode,
    driver: MatchPropConst.driver,
    pickup: MatchPropConst.pickup,
    dropOff: MatchPropConst.dropOff,
    company: MatchPropConst.company
  };

  protected pdfurl: boolean;
  protected imageUrl: string | null = null;

  protected config = {
    checkCrossOrigin: true,
    background: false,
    checkOrientation: true,
    scalable: true,
    rotatable: true
  };
  public _cropper: any;
  showIndividual = true;
  private subscriptions: Subscription[] = [];
  private isLoadingManifest = false;
  constructor(
    protected sanitizer: DomSanitizer,
    private _manifestService: ManifestService,
    protected Inject: Injector,
    private loading: T2LoadingService,
    private _fb: FormBuilder,
    private providersBillingService: ProvidersBillingService,
    private sweetAlertHelper: SweetAlertHelper,
  ) {
    super('app-manifest', Inject);
    this.gridTrips = <GridOptions> {};
    this.gridTrips.columnDefs = this.getColumnDefs();
    this.form = _fb.group({
      confirm: false,
      crop: false,
    });
    this.subscriptions.push(this.form.get('confirm').valueChanges.subscribe(
      (value: boolean) => {
        if (!value) {
          this.form.get('crop').setValue(false);
        }
      }
    ));
    this.disabledSelect(true);
    this.observables();
  }

  ngAfterViewInit(): void {
    this.show = false;
    this.__CANVAS_CTX = (<HTMLCanvasElement>this.__CANVAS.nativeElement).getContext('2d');
  }

  ngOnInit() {}

  observables() {
    this.subscriptions.push(
      this.actionsList$.subscribe((response) => {
        if (response && response.length ) {
          this.uploadManifest = response.includes('Upload Manifest');
          this.approveDenyClaim = response.includes('Approve/Deny Claim');
          this.loadData(false);
        }
      })
    );
  }

  loadProcessManifest() {
    this.subscriptions.push(
      this._manifestService.getManifest(this.tripIdInput).subscribe({
        next: (data) => {
          if (data) {
            this.scoreValue = data.scorematch;
            if (data.tripmatchresponse) {
              this.matchInfoTrip = data.tripmatchresponse;
            } else {
              this.matchInfoTrip = [];
            }
          }
        },
        error: (err) => {
          this.sweetAlertHelper.captureException(err);
        },
      })
    );
  }

  loadData(show?: boolean) {
    if (this.tripids && this.tripids.length > 1 && this.swicth ) {
      this.getTripsByIds();
      this.showIndividual = false;
      setTimeout(() => {
        this.swicth = false;
        this.file.nativeElement.click();
      }, 500);
    } else if (this.tripIdInput) {
      this.tripids = [this.tripIdInput];
      this.showIndividual = true;
      if (this.infTrip || this.isLoadingManifest) {
        return;
      }
      this.isLoadingManifest = true;
      this.loading.show('Loading Manifest');
      this.subscriptions.push(
        this._manifestService
          .getManifest(this.tripIdInput)
          .finally(() => {
            this.isLoadingManifest = false;
            this.loading.hiden();
          })
          .subscribe({
            next: (data) => {
              this.infTrip = data;
              this.fileLink = data && data.attachment ? data.attachment : null;
              this._manifestService.setManifestLoaded(!!this.fileLink);
              if (data && data.paymentstatusid) {
                this._manifestService.setPaymentStatusId(data.paymentstatusid);
              }
              if (data) {
                if (!this.approveDenyClaim) {
                  this.cleanCanvas();
                }
                this.show = true;
                this.setImage(data.attachment);
                this.reviewedName = data.reviewedby;
                this.reviewedByOn = data.reviewedonformatted;
                this.isUnableToSign = data.unabletosign ? '(UTS)' : '';
                this.scoreValue = data.scorematch;
                this.matchInfoTrip = data.tripmatchresponse;
              } else {
                this._manifestService.setManifestLoaded(false);
                if (!show) {
                  if (this.autoOpen && this.uploadManifest && this.file && this.file.nativeElement) {
                    this.file.nativeElement.click();
                  }
                }
              }
            },
            error: (err) => {
              this.fileLink = null;
              this._manifestService.setManifestLoaded(false);
              const capturePromise = this.sweetAlertHelper.captureException(err);
              if (capturePromise) {
                capturePromise.then(() => {
                  if (this.autoOpen && this.uploadManifest && this.file && this.file.nativeElement) {
                    this.file.nativeElement.click();
                  }
                });
              }
            },
          }),
      );
    }
  }

 changePages() {
  //  this.++__CURRENT_PAGE>0 && this.++__CURRENT_PAGE<=this.__TOTAL_PAGES? showPage(++__CURRENT_PAGE, true): __CURRENT_PAGE = null
 }
  saveManifest() {
    this.sweetAlertHelper.createCustomAlert({
      title: '',
      text: 'Are you sure you want select the page ' + this.__CURRENT_PAGE + '?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes'
    }).then((result) => {
      if (result.value) {
        this.loading.show('Loading Manifest');
        if (this.base64File && this.tripIdInput) {
          this.str = this.base64File;
          this.strSubstr = this.str.substr(0, this.str.lastIndexOf(','));
          this.b64File = this.base64File.replace(this.strSubstr + ',', '');
          this._manifestService.postTripManifest(this.generateData()).subscribe(
            data => {
              this.loading.hiden();
              this.__PDF_DOC = null;
              this.isLoadingManifest = false;
              this._manifestService.setManifestLoaded(true);
              this.sweetAlertHelper.createCustomAlert({
                text: 'Manifest registered...',
                type: 'success',
                confirmButtonText: 'Ok'
              }).then(() => {
                this.resetView();
                this.onRealoadCheck.emit();
                this.providersBillingService.ReloadGridUnprocess$.emit(true);
              });
              this.loadProcessManifest();
            }
          );
        } else {
          alert(this.base64File);
        }
      }
    });


  }

  private resetView() {
    this.pdfurl = false;
    this.imageUrl = null;
    this.base64File = null;
    this.b64File = null;
    this.str = null;
    this.strSubstr = null;
    this.b64File = null;
    this.form.get('confirm').setValue(false);
    this.form.get('crop').setValue(false);
    // this.popManifest.close();
  }

  showPDF(pdf_url): void {
    if (this.__PDF_DOC) {
      return;
    }
    if (this.pdfurl) {
      this.resetView();
    }
    const that = this;
    pdfjsLib.getDocument(pdf_url).promise.then(function (pdf_doc) {
      that.__PDF_DOC = pdf_doc;
      that.__TOTAL_PAGES = that.__PDF_DOC.numPages;
      that.showPage(1, false);
      that.preloadAllPages();
    }).catch(function (error) {
      that.setImage(pdf_url);
      that.disabledSelect(true);
      // that.pdfurl = that.sanitizer.bypassSecurityTrustResourceUrl(pdf_url);
      // alert(error.message);
    });
  }

  showPage(page_no, prev) {

    this.storedRects = [];
    this.buff = [];
    this.__PAGE_RENDERING_IN_PROGRESS = 1;
    this.__CURRENT_PAGE = page_no;
    // Fetch the page
    const that = this;
    this.__PDF_DOC.getPage(page_no).then(function (page) {
      const width = window.screen.availWidth - 50;
      // As the canvas is of a fixed width we need to set the scale of the viewport accordingly
      const scale_required = width / page.getViewport(1).width;
      // Get viewport of the page at required scale //the scale is the % in the pdf file
      const viewport = page.getViewport(scale_required);
      // Set canvas width
      // Set canvas height
      that.__CANVAS.nativeElement.width = width;
      that.__CANVAS.nativeElement.height = viewport.height;

      const renderContext = {
        canvasContext: that.__CANVAS_CTX,
        viewport: viewport
      };
      // Render the page contents in the canvas
      page.render(renderContext).then(function () {
        that.__PAGE_RENDERING_IN_PROGRESS = 0;
        if (prev) {
          that.img.src = that.allPages[page_no - 1].toDataURL();
        } else {
          that.img.src = that.__CANVAS.nativeElement.toDataURL();
        }
      });
    });
  }

  /**
   * this get info to populate grid
   */
  getTripsByIds() {
    this._manifestService.getTripsByIds(this.tripids).subscribe(
      data => {
        if (this.gridTrips && this.gridTrips.api) {
          this.gridTrips.api.setRowData(data);
        }
      }
    );
  }

  onAttachDocument(event) {
    if (event.target.files.length) {
      this.disabledSelect(true);
      this.cleanCanvas();
      this.__PDF_DOC = null;
      const url = URL.createObjectURL(event.target.files[0]);
      this.showPDF(url);
      this.show = true;
    }
  }

  // Previous page of the PDF
  prevPage(): void {
    if (this.__CURRENT_PAGE !== 1) {
      this.cleanCanvas();
      this.showPage(--this.__CURRENT_PAGE, true);
    }
    if (this.form.get('crop').value ) {
      this._cropper.destroy();
      this.form.get('crop').setValue(false);
    }
  }
  load(): void {
    if (this.__CURRENT_PAGE < 1) {
      this.__CURRENT_PAGE = 1;
    }
      this.cleanCanvas();
      this.showPage(--this.__CURRENT_PAGE, true);
  }

  // Next page of the PDF
  nextPage(): void {
    if (this.__CURRENT_PAGE !== this.__TOTAL_PAGES) {
      this.cleanCanvas();
      this.showPage(++this.__CURRENT_PAGE, true);
    }
    if ( this.form.get('crop').value) {
      this._cropper.destroy();
      this.form.get('crop').setValue(false);
    }
  }

  cleanCanvas(): void {
    this.__CANVAS_CTX.clearRect(0, 0, this.__CANVAS_CTX.canvas.width, this.__CANVAS_CTX.canvas.height);
    this.img.src = this.__CANVAS.nativeElement.toDataURL();
  }

  removeFile() {
    this.sweetAlertHelper.createCustomAlert({
      title: 'Are you sure?',
      text: 'You won´t be able to revert this!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        this.deteleManifest();
      }
    });

  }

  preloadAllPages() {
    this.allPages = [];
    const that = this;
    for (let i = 1 ; i <= this.__TOTAL_PAGES; i++) {
      this.__PDF_DOC.getPage(i).then(function (page) {
        const width = window.screen.availWidth - 50;
        // As the canvas is of a fixed width we need to set the scale of the viewport accordingly
        const scale_required = width / page.getViewport(1).width;
        // Get viewport of the page at required scale //the scale is the % in the pdf file
        const viewport = page.getViewport(scale_required);
        const canv = document.createElement('canvas');
        const canv_con = canv.getContext('2d');
        // Set canvas width
        // Set canvas height
        canv.width = width;
        canv.height = viewport.height;

        const renderContext = {
          canvasContext: canv_con,
          viewport: viewport
        };
        // Render the page contents in the canvas
        page.render(renderContext).then(function () {
          that.allPages.push(canv);
          if (i === that.__TOTAL_PAGES) {
            that.disabledSelect(false);
          }
        });
      });
    }
  }

  onSave() {
    let width = (<HTMLCanvasElement>this.__CANVAS.nativeElement).width;
    let height = (<HTMLCanvasElement>this.__CANVAS.nativeElement).height;
    let pdf = null;
    // set the height and width for the output pdf file
    if (width > height) {
      pdf = new jsPDF('l', 'px', [width, height]);
    } else {
      pdf = new jsPDF('p', 'px', [height, width]);
    }
    width = pdf.internal.pageSize.getWidth();
    height = pdf.internal.pageSize.getHeight();

    if (this.form.get('crop').value) {
      pdf.addImage(this.crop(), 'PNG', 0, 0, width, height);
    } else {
      pdf.addImage(this.__CANVAS.nativeElement, 'PNG', 0, 0, width, height);
    }

    // pdf.addImage(this.__CANVAS.nativeElement, 'PNG', 0, 0, width, height);
    // this.base64File = btoa(pdf.output());
    this.base64File = this.__CANVAS.nativeElement.toDataURL();
    this.saveManifest();
    // pdf.save('download.pdf');
  }

  deteleManifest() {
    if (this.tripIdInput || this.tripids) {
      this.loading.show('Delete Manifest');
      this._manifestService.postTripManifest(this.generateData(true)).subscribe(
        data => {
          this.loading.hiden();
          this.show = false;
          this.fileLink = null;
          this._manifestService.setManifestLoaded(false);
          this.sweetAlertHelper.createCustomAlert({
            title: 'Deleted!',
            text: 'Your file has been deleted.',
            type: 'success'
          }).then(() => {
            this.resetView();
            this.__PDF_DOC = null;
            this.isLoadingManifest = false;
            this.loadData(true);
            this.onRealoadCheck.emit();
          });
          this.loadProcessManifest();
        },
        (err: any) => {
          this.loading.hiden();
          this.sweetAlertHelper.createCustomAlert({ text: err.message, type: 'error', title: 'Error' });
        }
      );
    }
  }

  eventApproval(e) {
    this.eventManifest.emit(e);
  }

  onConfirm() {
    if (this.form.get('crop').value) {
      this._cropper = new Cropper(this.__CANVAS.nativeElement, this.config);
    } else {
      this._cropper.destroy();
    }
  }

  crop() {
    const imgs = this._cropper.getCroppedCanvas({
      width: this.__CANVAS_CTX.canvas.width,
      height: this.__CANVAS_CTX.canvas.height
    }).toDataURL('image/png', 60 / 100);
    return imgs;
  }

  setImage(url) {
    this.__TOTAL_PAGES = this.allPages.length;
    // this.pdfurl = this.sanitizer.bypassSecurityTrustResourceUrl(url);

    if (this._cropperImg) {
      this._cropperImg.destroy();
    }

    this.imageUrl = url;
    this.image.nativeElement.src = url;
    this._cropperImg = new Cropper(this.image.nativeElement, this.configImg);

    setTimeout(() => {
      this._cropperImg.clear();
      this._cropperImg.setDragMode('move');
    }, 2000);

    this.pdfurl = true;
  }

  openFullscreen(): void {
    const el = this.fs.nativeElement;

    if (!document.fullscreenElement && !document.webkitFullscreenElement) {  // current working methods
      if (el.requestFullscreen) {
        el.requestFullscreen();
      } else if (el.mozRequestFullScreen) {
        el.mozRequestFullScreen();
      } else if (el.webkitRequestFullscreen) {
        // el.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      } else if (el.msRequestFullscreen) {

        el.msRequestFullscreen();
      }
    }
  }

  closeFullscreen(): void {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    // } else if (document.msExitFullscree) {
    //   document.msExitFullscreen();
    // } else if (document.mozCancelFullScreen) {
    //   document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    }
  }

  onGridReady(grid) {
    grid.api.sizeColumnsToFit();
  }

  /**
   * this. define a columnDefs
   */
  getColumnDefs() {
    return [
      {
        headerName: 'Trip Date',
        width: 30,
        field: 'dateofservice'
      },
      {
        headerName: 'Rider',
        width: 60,
        field: 'rider'
      },
      {
        headerName: 'Trip #',
        width: 30,
        field: 'consecutive'
      },
      {
        headerName: 'Call Type',
        width: 40,
        field: 'calltype'
      },
      {
        headerName: 'Leg',
        width: 12,
        field: 'leg'
      },
      {
        headerName: 'Signature',
        width: 40,
        field: 'tripreasonsign'
      },
      {
        headerName: 'Loaded Mi.',
        width: 30,
        field: 'miles'
      },
      {
        headerName: 'Driver',
        width: 60,
        field: 'driver'
      },
      {
        headerName: 'PUT',
        width: 30,
        field: 'actualpickup'
      },
      {
        headerName: 'PU Ad.',
        width: 60,
        field: 'puaddress'
      },
      {
        headerName: 'DOT',
        width: 30,
        field: 'actualdropoff'
      },
      {
        headerName: 'DO Add',
        width: 60,
        field: 'doaddress'
      }
    ];
  }
  /**
   * @description para habilitar el selector de pagina
   * @param disabled
   */
  public disabledSelect(disabled: boolean): void {
    if (disabled) {
      if (this.form.get('confirm').value) {this.form.get('confirm').setValue(false); }
      if (this.form.get('confirm').enabled) {this.form.get('confirm').disable(); }
    } else if (this.form.get('confirm').disabled) {
      this.form.get('confirm').enable();
    }
  }
  /**
   * @description genera la data para manifest
   */
  private generateData(clear?: boolean): IDataManifestCreate {
    return {
      trips: (this.tripids && this.tripids.length) ? this.tripids : [this.tripIdInput],
      filebase64: clear ? null : this.b64File,
    };
  }

  toggleReviewed(): boolean {
    return this.reviewedName && this.reviewedByOn;
  }

  processManifest() {
    if (!this.scoreValue) {
      this.loading.show();
      this.subscriptions.push(
        this._manifestService
          .processManifest(this.tripIdInput)
          .finally(() => this.loading.hiden())
          .subscribe({
            next: (data) => {
              this.sweetAlertHelper.createCustomAlert({
                title: 'Trips Validated!',
                text: data,
                type: 'success',
              });
              this.loadProcessManifest();
            },
            error: (err: any) => {
              this.sweetAlertHelper.captureException(err);
            },
          })
      );
    }
  }

  getMatchValue(property: string): string | null {
    if (!property || !this.matchInfoTrip || !this.matchInfoTrip.length) {
      return null;
    }
    const found = this.matchInfoTrip.find((m: IMatchInfoTrip) => m.property === property);
    return found ? found.matchvalue : null;
  }

  getMatchClass(property: string): string {
    if (!property || !this.matchInfoTrip || !this.matchInfoTrip.length) {
      return '';
    }
    const found = this.matchInfoTrip.find((m: IMatchInfoTrip) => m.property === property);
    if (!found) { return ''; }
    return found.matched ? 'color-success' : 'color-danger';
  }

  getPreferredVehicleMatchValue(): string | null {
    const prop = this.getMatchFirstProperty();
    return prop ? this.getMatchValue(prop) : null;
  }

  getMatchFirstProperty(): string | null {
    const properties = [this.matchProp.vin, this.matchProp.vehicleCode];
    const foundProp = properties.find((p) =>
      this.matchInfoTrip.some(
        (m: IMatchInfoTrip) =>
          m.property === p && !!m.matchvalue
      )
    );
    return foundProp ? foundProp : null;
  }

   get isMatchInfoTrip(): boolean {
    return !!(this.matchInfoTrip && this.matchInfoTrip.length);
  }

  get vehicleInformation(): string {
    if (
      !this.infTrip ||
      !this.infTrip.vehicle
    ) {
      return null;
    }
    return this.getMatchFirstProperty() === this.matchProp.vin &&
      this.getVinValidClass()
      ? this.infTrip.vehicle.vin
      : this.infTrip.vehicle.code;
  }

  getVinValidClass (): boolean {
    return this.getMatchClass(this.matchProp.vin) === 'color-success';
  }

  get signatureValidClass (): boolean {
    return this.getMatchClass(this.matchProp.signature) === 'color-success';
  }

  get isValidScoreMatch(): boolean {
    return this.scoreValue >= 0;
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.forEach((sub) => sub.unsubscribe());
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/manifest/components/manifest/manifest.component.ts